import {
  FETCH_EMP_DISCRIPENCY_REQUEST,
  FETCH_EMP_DISCRIPENCY_SUCCESS,
  FETCH_EMP_DISCRIPENCY_FAILURE,
  FETCH_ATTENDANCE_SUMMARY_REQUEST,
  FETCH_ATTENDANCE_SUMMARY_SUCCESS,
  FETCH_ATTENDANCE_SUMMARY_FAILURE,
  FETCH_LOCATIONS_REQUEST,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAILURE,
} from "../constants/EmpDiscripencyConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,
  summaryLoading: false,
  summaryData: [],
  summaryError: null,
  locationsLoading: false,
  locationsData: [],
  locationsError: null,
};

const EmpDiscripencyReducer = (state = initialState, action) => {
  switch (action.type) {
    // Locations Actions
    case FETCH_LOCATIONS_REQUEST:
      return {
        ...state,
        locationsLoading: true,
        locationsError: null,
      };
    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        locationsLoading: false,
        locationsData: action.payload,
        locationsError: null,
      };
    case FETCH_LOCATIONS_FAILURE:
      return {
        ...state,
        locationsLoading: false,
        locationsError: action.payload,
      };

    // Attendance Summary Actions
    case FETCH_ATTENDANCE_SUMMARY_REQUEST:
      return {
        ...state,
        summaryLoading: true,
        summaryError: null,
      };
    case FETCH_ATTENDANCE_SUMMARY_SUCCESS:
      return {
        ...state,
        summaryLoading: false,
        summaryData: action.payload,
        summaryError: null,
      };
    case FETCH_ATTENDANCE_SUMMARY_FAILURE:
      return {
        ...state,
        summaryLoading: false,
        summaryError: action.payload,
      };

    // Absent Details Actions
    case FETCH_EMP_DISCRIPENCY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_EMP_DISCRIPENCY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_EMP_DISCRIPENCY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default EmpDiscripencyReducer;


// import {
//   FETCH_EMP_DISCRIPENCY_REQUEST,
//   FETCH_EMP_DISCRIPENCY_SUCCESS,
//   FETCH_EMP_DISCRIPENCY_FAILURE,
//   FETCH_ATTENDANCE_SUMMARY_REQUEST,
//   FETCH_ATTENDANCE_SUMMARY_SUCCESS,
//   FETCH_ATTENDANCE_SUMMARY_FAILURE,
// } from "../constants/EmpDiscripencyConstants";

// const initialState = {
//   loading: false,
//   data: [],
//   error: null,
//   summaryLoading: false,
//   summaryData: [],
//   summaryError: null,
// };

// const EmpDiscripencyReducer = (state = initialState, action) => {
//   switch (action.type) {
//     // Attendance Summary Actions
//     case FETCH_ATTENDANCE_SUMMARY_REQUEST:
//       return {
//         ...state,
//         summaryLoading: true,
//         summaryError: null,
//       };
//     case FETCH_ATTENDANCE_SUMMARY_SUCCESS:
//       return {
//         ...state,
//         summaryLoading: false,
//         summaryData: action.payload,
//         summaryError: null,
//       };
//     case FETCH_ATTENDANCE_SUMMARY_FAILURE:
//       return {
//         ...state,
//         summaryLoading: false,
//         summaryError: action.payload,
//       };

//     // Absent Details Actions
//     case FETCH_EMP_DISCRIPENCY_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };
//     case FETCH_EMP_DISCRIPENCY_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         data: action.payload,
//         error: null,
//       };
//     case FETCH_EMP_DISCRIPENCY_FAILURE:
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//       };

//     default:
//       return state;
//   }
// };

// export default EmpDiscripencyReducer;